import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { getValueForBreakpoint } from 'utils/helpers'
import { useClientWidth } from 'utils/hooks'
import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitAspectRatio } from '../../SkeletonUnit.h'
import { breakpointsMarginPlayer, breakpointsWidthPlayer } from './breakpoints'

export interface IPlayerSkeletonUnitProps extends ISkeletonUnitProps {
  breakpointsWidth?: {}
  breakpointsMargin?: {}
}

export const PlayerSkeletonUnit = ({
  aspectRatio = SkeletonUnitAspectRatio.PlayerDefault,
  breakpointsWidth = breakpointsWidthPlayer,
  breakpointsMargin = breakpointsMarginPlayer,
  ...rest
}: IPlayerSkeletonUnitProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const validWidth = breakpointsWidth
    ? getValueForBreakpoint(clientWidth, breakpointsWidth)
    : rest.width
  const validMargin = breakpointsMargin
    ? getValueForBreakpoint(clientWidth, breakpointsMargin)
    : rest.margins

  return (
    <SkeletonUnit
      width={validWidth}
      aspectRatio={aspectRatio}
      margins={validMargin}
      {...rest}
    />
  )
}
